// extracted by mini-css-extract-plugin
module.exports = {"main":"Hr_main__11eDX","margin":"Hr_margin__kz7yT"};